
export default function(nga, admin) {
  var salesreport = admin.getEntity('sales_by_expiration')
  salesreport
    .listView()
    .title(
      `<h4>Expirations list <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>`
    )
    .batchActions([])
    .fields([
      nga.field('login_datum.username', 'string').label('Smartcard'),
      nga.field('combo.product_id').label('Product CAS Code'),
      nga
        .field('end_date', 'date')
        .cssClasses('hidden-xs')
        .label('Expiration date')
    ])
    .filters([
      nga.field('username', 'string').attributes({ placeholder: 'Client' }),
      nga
        .field('startsaledate', 'date')
        .attributes({ placeholder: 'From date' })
        .label('From date')
        .pinned(true),
      nga
        .field('endsaledate', 'date')
        .attributes({ placeholder: 'To date' })
        .label('To date')
        .pinned(true),
    ])
    .exportFields([
      nga.field('login_datum.username', 'string').label('smartcardno/username'),
      nga.field('combo.product_id').label('productid (cascode)'),
      nga.field('end_date', 'date').label('expirydate')
    ]);

  return salesreport;
}



// WEBPACK FOOTER //
// ./js/sales_by_expiration/config.js